import { render, staticRenderFns } from "./SaveHistorty.vue?vue&type=template&id=0e6d8696&"
import script from "./SaveHistorty.vue?vue&type=script&lang=js&"
export * from "./SaveHistorty.vue?vue&type=script&lang=js&"
import style0 from "./SaveHistorty.vue?vue&type=style&index=0&id=0e6d8696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports